import { render, staticRenderFns } from "./MerchantWxVoucher.vue?vue&type=template&id=e9798e2e&scoped=true&"
import script from "./MerchantWxVoucher.vue?vue&type=script&lang=js&"
export * from "./MerchantWxVoucher.vue?vue&type=script&lang=js&"
import style0 from "./MerchantWxVoucher.vue?vue&type=style&index=0&id=e9798e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9798e2e",
  null
  
)

export default component.exports